import React from 'react';

const Avatar = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24"
      cy="24"
      r="23"
      fill="#E3E4E7"
      stroke="#E3E4E7"
      strokeWidth="2"
    />
    <circle
      cx="23.5931"
      cy="23.5931"
      r="20.5931"
      fill="#E3E4E7"
      stroke="#E3E4E7"
      strokeWidth="2"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="44"
      height="44"
    >
      <circle
        cx="23.5931"
        cy="23.5931"
        r="20.5931"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.1649 14.2048C30.2588 10.6373 27.4423 7.7269 23.8747 7.63302C23.7808 7.63302 23.6869 7.63302 23.5931 7.63302C20.0255 7.53913 17.1151 10.3556 17.0212 13.9232C17.0212 14.0171 17.0212 14.111 17.0212 14.2048C17.0212 14.9559 17.7723 18.6174 17.7723 18.6174C18.3356 21.8094 20.401 24.532 23.5931 24.532C26.7851 24.532 28.8505 21.9033 29.4138 18.6174C29.4138 18.6174 30.1649 14.9559 30.1649 14.2048Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.63306 38.145V37.4879C7.63306 34.5775 9.79237 32.4182 12.7028 31.6671L23.5932 29.6956L34.5775 31.761C37.394 32.6059 39.5534 34.5775 39.5534 37.5817V38.2389C39.5534 38.2389 38.6425 44.8162 35.5038 46.7211C32.3651 48.6261 23.5943 47.9249 23.5943 47.9249C23.5943 47.9249 14.2301 48.7212 10.9658 46.7211C7.70154 44.721 7.63306 38.145 7.63306 38.145Z"
        fill="white"
      />
    </g>
  </svg>
);

export default Avatar;
